import {Place, PlaceListing} from '../types/Place';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class PlacesService {
  public async getAllPlaces(): Promise<PlaceListing[]> {
    return handleError(
      () => httpClient.get<PlaceListing[]>('/places'),
      'Error fetching places:',
      () => []
    );
  }

  public async getPlace(id: string): Promise<Place> {
    return handleError(
      () => httpClient.get<Place>(`/places/${id}`),
      'Error fetching place:'
    );
  }

  public async createPlace(place: Omit<Place, 'id'>): Promise<void> {
    const placeWithId = {
      ...place,
      id: crypto.randomUUID()
    };
    return handleError(
      () => httpClient.post<void>('/places', placeWithId),
      'Error creating place:'
    );
  }

  public async updatePlace(place: Place): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/places/${place.id}`, place),
      'Error updating place:'
    );
  }

  public async deletePlace(id: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/places/${id}`),
      'Error deleting place:'
    );
  }
}

const placesService = new PlacesService();
export default placesService;
